import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_e17114db: FaireBrandEntity = {
  token: "b_e17114db",
  type: "brand",
  name: "Big Picture Farm",
  avatarUrl: "https://cdn.faire.com/fastly/7fb7ff30ec11890668d9c8f816c3243945eb85a234785244b09e2a857af3c59b.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/9a37021ef5be870ee14eec98e204081821775a0256d3be014566b03eea1203a2.png",
  logoUrl: "https://cdn.faire.com/fastly/7fb7ff30ec11890668d9c8f816c3243945eb85a234785244b09e2a857af3c59b.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/9a37021ef5be870ee14eec98e204081821775a0256d3be014566b03eea1203a2.png",
  location: "Townshend, VT, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 76,
  isTopShop: true,
  isInsider: true,
  description: "Started in 2010 by Louisa Conrad and Lucas Farrell (and now joined by our daughters, Maisie and Minna), Big Picture Farm is a small hillside goat dairy and farmstead confectionery and creamery located in southern Vermont. Our award-winning goat milk caramels and farmstead cheeses are made with fresh, raw, creamy goat’s milk from our herd of 40 healthy and happy, free-ranging companions. An Animal-Welfare-Approved farm, the health and happiness of our animals is the center around which our farm and farm products revolve. Our mission is also to integrate agriculture and narrative in a fresh way that properly evokes the place, animals, and work in order to bring to life the exciting and unpredictable evolution of our products, farm, and lives. Our goal is spelled out in our name: to provide our customers with the rich context surrounding our products. We therefore invite you to meet and get to know all of our goats and to follow us through the seasons. ",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:04.105Z",
    importedBy: "entity-db-cli"
  }
};
